import React from 'react';

import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import Button from 'components/Button';

export const styles = theme => ({
  sticky: {
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    margin: 'auto',
    display: 'flex',
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.mobileStepper,
  },
});

export function StickyButton({ classes, children, ...buttonProps }) {
  return (
    <div className={classes.sticky}>
      <Button {...buttonProps}>{children}</Button>
    </div>
  );
}

StickyButton.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  buttonProps: PropTypes.object,
};

export default compose(withStyles(styles))(StickyButton);
